/** @internal */
export const OP_DONE = "Done" as const

/** @internal */
export type OP_DONE = typeof OP_DONE

/** @internal */
export const OP_INTERRUPTED = "Interrupted" as const

/** @internal */
export type OP_INTERRUPTED = typeof OP_INTERRUPTED

/** @internal */
export const OP_RUNNING = "Running" as const

/** @internal */
export type OP_RUNNING = typeof OP_RUNNING
